import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { ScrollToTop } from './components/layout/scrollTop/scrollToTop'
import { PageViewTracker } from './activity/PageViewTracker'
import { ToastProvider } from './components/ui/toast'

import { useAuthUserData, useUserOrganisations, useIsPcpReferralTeamLeader } from './authUserProvider'
import AdlHome from './containers/adl-home'
import Auth from './containers/auth'
import BulkActions from './containers/bulkActions'
import Cases from './containers/cases'
import Clients from './containers/clients'
import CreateClient from './containers/createClient'
import DsarStats from './containers/dsarStats'
import Foa from './containers/foa'
import LenderFoaResponses from './containers/foaResponse'
import FosCases from './containers/fosCases'
import FosIntroducers from './containers/fosIntroducers'
import FosTransfers from './containers/fosTransfers'
import GorillaHome from './containers/gorilla'
import Home from './containers/home'
import IntroducedCases from './containers/introducedCases'
import IntroducerStats from './containers/introducer-stats'
import LocStats from './containers/locStats'
import Login from './containers/login'
import Main from './containers/main'
import MailReferralHome from './containers/mr-home'
import PageNotFound from './containers/pageNotFound'
import PanacoHome from './containers/panaco'
import Poc from './containers/poc'
import ReportLinks from './containers/reportLinks'
import ClaimValuations from './containers/claimValuations'
import SentinelHome from './containers/sentinel-home'
import ViewCase from './containers/viewCase'
import ViewClient from './containers/viewClient'
import ViewWebsiteClient from './containers/viewWebsiteClient'
import WebsiteClaimsClients from './containers/websiteClaimsClients'
import KnowledgeBase from './containers/knowledgebase'
import Chatbot from './containers/chatbot'
import VisionLaunchHome from './containers/visionLaunch'
import AllegiantHome from './containers/allegiant'
import ReEngagementOverview from './containers/reEngagementOverview'
import ReEngagementSearch from './containers/reEngagementSearch'
import ClientSearch from './containers/clientSearch'
import ILManagement from './containers/ilManagement'
import ILAddClients from './containers/ilAddClients'
import ILClientDetails from './containers/ilClientDetails'
import MailReferralILStats from './containers/mailReferralILStats'
import AdlILStats from './containers/adlILStats'
import PCPMO26Home from './containers/pcpmo26-home'
import FairClaimHome from './containers/fairclaim-home'
import SentinelMattersHome from './containers/sentinel-matters-home'
import MfcHome from './containers/mfc-home'
import PcpReferralOverview from './containers/pcp-referral-overview'
import PcpReferralEngagement from './containers/pcp-referral-engagement'
import PcpReferralEngagementStats from './containers/pcp-referral-engagement-stats'
import PcpReferralUsers from './containers/pcp-referral-users'
import PcpReferralAddClient from './containers/pcp-referral-add-client'
import PcpReferralEsignHistory from './containers/pcp-referral-esign-history'
import PcpReferralTeamLeaderStats from './containers/pcp-referral-team-leader-stats'
import CollectFundingClients from './containers/collectFundingClients'
import ManualAddClient from './containers/manualAddClient'
import Contracts from './containers/contracts'
import NeedsSortingClients from './containers/needsSortingClients'
import LenderEdits from './containers/lenderEdits'
import SignatureReview from './containers/signatureReview'
import LoaTracker from './containers/loaTracker'
import StaffEmailSignature from './containers/staffEmailSignature'
import ViewThruBatch from './containers/viewThruBatch'
import ViewThruAllBatches from './containers/viewThruAllBatches'
import OmnibusClaims from './containers/omnibusClaims'
import OmnibusGroupDetail from './containers/omnibusGroupDetail'
import FairclaimApi from './containers/fairclaimApi'
import FFJApi from './containers/ffjApi'
import AnalyseSchema from './containers/analyseSchema'
import IntroducersDirectory from './containers/introducersDirectory'
import CancellationReadiness from './containers/cancellationReadiness'
import ClientSchemaDetails from './containers/clientSchemaDetails'
import AllocateClaims from './containers/allocateClaims'
import AllocateClaimsFull from './containers/allocateClaimsFull'
import FundingBatchDetails from './containers/fundingBatchDetails'
import FundingClientDetails from './containers/fundingClientDetails'
import IneligibleFundingClients from './containers/ineligibleFundingClients'
import IntroducerFundingGap from './containers/introducerFundingGap'
import Users from './containers/users'
import InsuranceAuditAdmin from './containers/insuranceAuditAdmin'
import OmnibusBatchVisibility from './containers/omnibusBatchVisibility'
import OmnibusCommsUpload from './containers/omnibusCommsUpload'
import ApprovedLenders from './containers/approvedLenders'
import StyleGuide from './containers/styleGuide'
import InsuranceAudit from './containers/insuranceAudit'
import InsuranceAuditClientDetails from './containers/insuranceAuditClientDetails'
import MBFCheckHome from './containers/mbf-home'
import CronScrapers from './containers/cronScrapers'
import UserActivity from './containers/userActivity'
import DocumentBundleAccessBatches from './containers/documentBundleAccessBatches'
import DocumentBundleAccessBatch from './containers/documentBundleAccessBatch'
import DocumentBundleAccessDetail from './containers/documentBundleAccessDetail'
import DocumentBundleAccessKeys from './containers/documentBundleAccessKeys'
import CommsLocBatches from './containers/commsLocBatches'
import CommsDocumentIngest from './containers/commsDocumentIngest'
import CommsInboxRedirect from './containers/commsInboxRedirect'
import CommsMailboxes from './containers/commsMailboxes'
import CommsMailboxWorkspace from './containers/commsMailboxWorkspace'
import CommsSearch from './containers/commsSearch'
import CommsCategories from './containers/commsCategories'
import CommsModels from './containers/commsModels'
import CommsPipeline from './containers/commsPipeline'
import CommsAgentActions from './containers/commsAgentActions'
import MilitaryHearingLossHome from './containers/militaryHearingLossHome'
import MilitaryHearingLossAdmin from './containers/militaryHearingLossAdmin'
import MilitaryHearingLossUsersPage from './containers/militaryHearingLossUsers'
import MilitaryHearingLossLeadTracker from './containers/militaryHearingLossLeadTracker'
import MilitaryHearingLossLeadsSearch from './containers/militaryHearingLossLeadsSearch'
import MilitaryHearingLossClientPage from './containers/militaryHearingLossClient'
import MilitaryHearingLossWebsiteVisitors from './containers/militaryHearingLossWebsiteVisitors'
import SrdsHome from './containers/srdsHome'
import SrdsClient from './containers/srdsClient'
import SrdsClaim from './containers/srdsClaim'
import Profile from './containers/profile'
import PageGuard from './access/PageGuard'
import { usePageAccess } from './access/pageAccess'
import { PAGE_ELEMENTS } from './access/pageElements.generated'
// import { Routes, Route } from "react-router-dom";

export default function AppRouter() {
    // Multi-org route gating: `organisations` is the union of the user's
    // primary Cognito org (`custom:organisation`) and any extras granted via
    // `dashboard_user_org_memberships`. `canSee()` returns true when an org is
    // anywhere in that list, so a user granted access to multiple orgs can
    // deep-link into any of them regardless of which sidebar is currently
    // active. Single-org users behave identically to the pre-multi-org branch.
    const authUser = useAuthUserData()
    const { organisations, primary } = useUserOrganisations()
    const { isLeader: isTeamLeader } = useIsPcpReferralTeamLeader()
    const canSee = (org: string) => organisations.includes(org)

    // Belt-and-braces: when the OAuth bootstrap hasn't populated the orgs
    // context yet, fall back to the user's Cognito attribute so the first
    // render after login still has *something* to gate routes with. This
    // matches the legacy behaviour and prevents a brief "no routes" flash.
    const fallbackOrg = !organisations.length && authUser ? authUser['custom:organisation'] : null
    const canSeeWithFallback = (org: string) => canSee(org) || fallbackOrg === org

    // Per-org page overrides from `dashboard_org_pages` (via /init). Pages
    // granted by an `allow` row are mounted below from the generated
    // PAGE_ELEMENTS registry; pages removed by a `block` row are intercepted
    // by <PageGuard /> so the org blocks below can stay exactly as written
    // (scripts/access/genPageCatalogue.mjs parses them for the baseline).
    const { allowedPages } = usePageAccess()

    console.log('FROM ROUTERAUTH organisations: ', organisations, 'primary:', primary)

    return (
        <ToastProvider>
            <Router>
                <ScrollToTop />
                <PageViewTracker />
                <Routes>
                    <Route path="/" element={<Main />}>
                        <Route index element={<Login />} />
                        <Route path="auth" element={<Auth />} />
                        <Route path="login" element={<Login />} />
                        {/* Self-service profile: every signed-in user, regardless of org.
                            The API resolves the account from the access token, so there is
                            nothing org-specific to gate here. */}
                        {(organisations.length > 0 || authUser) && <Route path="profile" element={<Profile />} />}

                        {/* Pages granted to one of the user's orgs by an `allow` override. */}
                        {allowedPages.map(
                            (p) =>
                                PAGE_ELEMENTS[p] && <Route key={`allowed:${p}`} path={p} element={PAGE_ELEMENTS[p]} />,
                        )}

                        <Route element={<PageGuard />}>
                            {canSeeWithFallback('ADL') && (
                                <>
                                    <Route path="adl-home" element={<AdlHome />} />
                                    <Route path="adl-il-stats" element={<AdlILStats />} />
                                </>
                            )}
                            {canSeeWithFallback('Sensible') && (
                                <>
                                    <Route path="re-engagement-overview" element={<ReEngagementOverview />} />
                                    <Route path="re-engagement-search" element={<ReEngagementSearch />} />
                                </>
                            )}
                            {canSeeWithFallback('MR') && (
                                <>
                                    <Route path="mail-referral-home" element={<MailReferralHome />} />
                                    <Route path="mail-il-stats" element={<MailReferralILStats />} />
                                </>
                            )}
                            {canSeeWithFallback('PCPMO26') && (
                                <>
                                    <Route path="pcpmo26-home" element={<PCPMO26Home />} />
                                </>
                            )}
                            {canSeeWithFallback('FairClaim') && (
                                <>
                                    <Route path="fairclaim-home" element={<FairClaimHome />} />
                                </>
                            )}
                            {canSeeWithFallback('SentinelMatters') && (
                                <>
                                    <Route path="sentinel-matters-home" element={<SentinelMattersHome />} />
                                </>
                            )}
                            {canSeeWithFallback('PCP Referral') && (
                                <>
                                    <Route path="pcp-referral/overview" element={<PcpReferralOverview />} />
                                    <Route path="pcp-referral/engagement" element={<PcpReferralEngagement />} />
                                    <Route
                                        path="pcp-referral/engagement-stats"
                                        element={<PcpReferralEngagementStats />}
                                    />
                                    <Route path="pcp-referral/users" element={<PcpReferralUsers />} />
                                    <Route path="pcp-referral/add-client" element={<PcpReferralAddClient />} />
                                    <Route path="pcp-referral/esign-history" element={<PcpReferralEsignHistory />} />
                                    <Route path="pcp-referral/team-stats" element={<PcpReferralTeamLeaderStats />} />
                                </>
                            )}
                            {canSeeWithFallback('PCP Referral Engagement') && (
                                <>
                                    <Route path="pcp-referral/engagement" element={<PcpReferralEngagement />} />
                                    <Route path="pcp-referral/add-client" element={<PcpReferralAddClient />} />
                                    {isTeamLeader && (
                                        <Route
                                            path="pcp-referral/team-stats"
                                            element={<PcpReferralTeamLeaderStats />}
                                        />
                                    )}
                                </>
                            )}
                            {canSeeWithFallback('MBFCheck') && (
                                <>
                                    <Route path="mbfcheck-home" element={<MBFCheckHome />} />
                                </>
                            )}
                            {canSeeWithFallback('MFC') && (
                                <>
                                    <Route path="mfc-home" element={<MfcHome />} />
                                </>
                            )}
                            {canSeeWithFallback('Vision Launch') && (
                                <Route path="vision-launch-home" element={<VisionLaunchHome />} />
                            )}

                            {/* Military Hearing Loss: agents get the client-facing pages; the MHL
                            Admin org and Sentinel additionally get agents, stats and the tracker. */}
                            {(canSeeWithFallback('Military Hearing Loss') ||
                                canSeeWithFallback('Military Hearing Loss Admin') ||
                                canSeeWithFallback('Sentinel')) && (
                                <>
                                    <Route
                                        path="military-hearing-loss/add-client"
                                        element={<MilitaryHearingLossHome />}
                                    />
                                    <Route
                                        path="military-hearing-loss/leads"
                                        element={<MilitaryHearingLossLeadsSearch />}
                                    />
                                    <Route
                                        path="military-hearing-loss/client/:clientId"
                                        element={<MilitaryHearingLossClientPage />}
                                    />
                                    {/* Scoped server-side: team leaders see their team (stats, overview,
                                    agents); plain agents get a 403 message. Admins / Sentinel see
                                    everything. */}
                                    <Route path="military-hearing-loss/admin" element={<MilitaryHearingLossAdmin />} />
                                    <Route
                                        path="military-hearing-loss/lead-tracker"
                                        element={<MilitaryHearingLossLeadTracker />}
                                    />
                                    <Route
                                        path="military-hearing-loss/website-visitors"
                                        element={<MilitaryHearingLossWebsiteVisitors />}
                                    />
                                    <Route
                                        path="military-hearing-loss/users"
                                        element={<MilitaryHearingLossUsersPage />}
                                    />
                                </>
                            )}

                            {canSeeWithFallback('Insurance Audit') && (
                                <>
                                    <Route path="insurance-audit" element={<InsuranceAudit />} />
                                    <Route
                                        path="insurance-audit/client/:clientId"
                                        element={<InsuranceAuditClientDetails />}
                                    />
                                </>
                            )}

                            {canSeeWithFallback('Score') && (
                                <>
                                    <Route path="allocate-claims" element={<AllocateClaims />} />
                                    <Route path="allocate-claims-full" element={<AllocateClaimsFull />} />
                                    <Route path="funding-batch/:batchId" element={<FundingBatchDetails />} />
                                    <Route path="funding-client/:clientId" element={<FundingClientDetails />} />
                                    <Route path="introducer-funding-gap" element={<IntroducerFundingGap />} />
                                </>
                            )}

                            {/* {canSeeWithFallback('Gorilla') && <Route path="gorilla-home" element={<GorillaHome />} />}
                    {canSeeWithFallback('Panaco') && <Route path="panaco-home" element={<PanacoHome />} />}
                    {canSeeWithFallback('Allegiant') && <Route path="allegiant-home" element={<AllegiantHome />} />} */}

                            {canSeeWithFallback('Sentinel') && (
                                <>
                                    <Route path="home" element={<Home />} />
                                    <Route path="sentinel-introducer-stats" element={<IntroducerStats />} />
                                    <Route path="adl-home" element={<AdlHome />} />
                                    <Route path="mail-referral-home" element={<MailReferralHome />} />
                                    <Route path="pcpmo26-home" element={<PCPMO26Home />} />
                                    <Route path="fairclaim-home" element={<FairClaimHome />} />
                                    <Route path="sentinel-matters-home" element={<SentinelMattersHome />} />
                                    <Route path="mfc-home" element={<MfcHome />} />
                                    <Route path="pcp-referral/overview" element={<PcpReferralOverview />} />
                                    <Route path="pcp-referral/engagement" element={<PcpReferralEngagement />} />
                                    <Route
                                        path="pcp-referral/engagement-stats"
                                        element={<PcpReferralEngagementStats />}
                                    />
                                    <Route path="pcp-referral/users" element={<PcpReferralUsers />} />
                                    <Route path="pcp-referral/add-client" element={<PcpReferralAddClient />} />
                                    <Route path="pcp-referral/esign-history" element={<PcpReferralEsignHistory />} />
                                    <Route path="pcp-referral/team-stats" element={<PcpReferralTeamLeaderStats />} />
                                    <Route path="mbfcheck-home" element={<MBFCheckHome />} />
                                    <Route path="mail-il-stats" element={<MailReferralILStats />} />
                                    <Route path="adl-il-stats" element={<AdlILStats />} />
                                    <Route path="panaco-home" element={<PanacoHome />} />
                                    <Route path="vision-launch-home" element={<VisionLaunchHome />} />
                                    <Route path="allegiant-home" element={<AllegiantHome />} />
                                    <Route path="gorilla-home" element={<GorillaHome />} />
                                    <Route path="sentinel-home" element={<SentinelHome />} />
                                    <Route path="FOA" element={<Foa />} />
                                    <Route path="foa-responses" element={<LenderFoaResponses />} />
                                    <Route path="POC" element={<Poc />} />
                                    <Route path="cases" element={<Cases />} />
                                    <Route path="client-search" element={<ClientSearch />} />
                                    <Route path="manual-add-client" element={<ManualAddClient />} />
                                    <Route path="contracts" element={<Contracts />} />
                                    {/* Legacy bookmarks for the two tools now merged into Contracts. */}
                                    <Route
                                        path="send-contract"
                                        element={<Navigate to="/contracts?tab=send" replace />}
                                    />
                                    <Route
                                        path="contract-templates"
                                        element={<Navigate to="/contracts?tab=vault" replace />}
                                    />
                                    <Route path="needs-sorting-clients" element={<NeedsSortingClients />} />
                                    <Route path="introducers-directory" element={<IntroducersDirectory />} />
                                    <Route path="cancellation-readiness" element={<CancellationReadiness />} />
                                    <Route path="comms/lenders" element={<LenderEdits />} />
                                    <Route path="lender-edits" element={<Navigate to="/comms/lenders" replace />} />
                                    <Route path="signature-review" element={<SignatureReview />} />
                                    <Route path="loa-tracker" element={<LoaTracker />} />
                                    <Route path="staff-email-signature" element={<StaffEmailSignature />} />
                                    <Route path="viewthru-batch" element={<ViewThruBatch />} />
                                    <Route path="viewthru-batch/analysis" element={<ViewThruAllBatches />} />
                                    <Route path="omnibus-claims" element={<OmnibusClaims />} />
                                    <Route path="omnibus-claims/:omnibusId" element={<OmnibusGroupDetail />} />
                                    <Route path="fairclaim-api" element={<FairclaimApi />} />
                                    <Route path="fairclaim-api/optics" element={<FairclaimApi />} />
                                    <Route path="fairclaim-api/linked-funding" element={<FairclaimApi />} />
                                    <Route path="fairclaim-api/test-suite" element={<FairclaimApi />} />
                                    <Route path="fairclaim-api/keys" element={<FairclaimApi />} />
                                    <Route path="ffj-api" element={<FFJApi />} />
                                    <Route path="ffj-api/optics" element={<FFJApi />} />
                                    <Route path="ffj-api/linked-funding" element={<FFJApi />} />
                                    <Route path="ffj-api/test-suite" element={<FFJApi />} />
                                    <Route path="ffj-api/keys" element={<FFJApi />} />
                                    <Route path="clients" element={<Clients />} />
                                    <Route path="view-case/:url_case_ref" element={<ViewCase />} />
                                    <Route path="view-client/:url_client" element={<ViewClient />} />
                                    <Route path="bulk-actions" element={<BulkActions />} />
                                    <Route path="introducers" element={<IntroducedCases />} />
                                    <Route path="FOS-imports" element={<FosCases />} />
                                    <Route path="FOS-introducers" element={<FosIntroducers />} />
                                    <Route path="FOS-transfers" element={<FosTransfers />} />
                                    <Route path="dsar-stats" element={<DsarStats />} />
                                    <Route path="loc-stats" element={<LocStats />} />
                                    <Route path="media-claims" element={<WebsiteClaimsClients />} />
                                    <Route
                                        path="media-claims/view-client/:url_client"
                                        element={<ViewWebsiteClient />}
                                    />{' '}
                                    <Route path="/media-claims/add-client" element={<CreateClient />} />
                                    <Route path="report-links" element={<ReportLinks />} />
                                    <Route path="claim-valuations" element={<ClaimValuations />} />
                                    <Route path="il-management" element={<ILManagement />} />
                                    <Route path="il-add-clients" element={<ILAddClients />} />
                                    <Route path="il-client/:id" element={<ILClientDetails />} />
                                    <Route path="knowledge-base" element={<KnowledgeBase />} />
                                    <Route path="chatbot" element={<Chatbot />} />
                                    <Route path="re-engagement-overview" element={<ReEngagementOverview />} />
                                    <Route path="re-engagement-search" element={<ReEngagementSearch />} />
                                    <Route path="collect-funding-clients" element={<CollectFundingClients />} />
                                    <Route path="analyse-schema" element={<AnalyseSchema />} />
                                    <Route path="analyse-schema/client/:clientKey" element={<ClientSchemaDetails />} />
                                    <Route path="allocate-claims" element={<AllocateClaims />} />
                                    <Route path="allocate-claims-full" element={<AllocateClaimsFull />} />
                                    <Route path="ineligible-funding-clients" element={<IneligibleFundingClients />} />
                                    <Route path="introducer-funding-gap" element={<IntroducerFundingGap />} />
                                    <Route path="funding-batch/:batchId" element={<FundingBatchDetails />} />
                                    <Route path="funding-client/:clientId" element={<FundingClientDetails />} />
                                    <Route path="users" element={<Users />} />
                                    <Route path="admin/credit-scrapers" element={<CronScrapers />} />
                                    <Route path="admin/user-activity" element={<UserActivity />} />
                                    <Route path="admin/insurance-audit" element={<InsuranceAuditAdmin />} />
                                    <Route path="admin/batch-visibility" element={<OmnibusBatchVisibility />} />
                                    <Route path="admin/omnibus-comms-upload" element={<OmnibusCommsUpload />} />
                                    <Route path="admin/approved-lenders" element={<ApprovedLenders />} />
                                    <Route path="admin/style-guide" element={<StyleGuide />} />
                                    <Route path="admin/document-access" element={<DocumentBundleAccessBatches />} />
                                    <Route path="admin/document-access/keys" element={<DocumentBundleAccessKeys />} />
                                    <Route
                                        path="admin/document-access/batch/:batchGroup"
                                        element={<DocumentBundleAccessBatch />}
                                    />
                                    <Route
                                        path="admin/document-access/access/:accessId"
                                        element={<DocumentBundleAccessDetail />}
                                    />
                                    <Route path="insurance-audit" element={<InsuranceAudit />} />
                                    <Route
                                        path="insurance-audit/client/:clientId"
                                        element={<InsuranceAuditClientDetails />}
                                    />
                                    {/* Comms Management */}
                                    <Route path="comms" element={<Navigate to="/comms/loc-batches" replace />} />
                                    <Route path="comms/loc-batches" element={<CommsLocBatches />} />
                                    <Route path="comms/document-ingest" element={<CommsDocumentIngest />} />
                                    <Route path="comms/inbox" element={<CommsInboxRedirect />} />
                                    <Route path="comms/mailboxes" element={<CommsMailboxes />} />
                                    <Route path="comms/mailboxes/:address" element={<CommsMailboxWorkspace />} />
                                    <Route path="comms/search" element={<CommsSearch />} />
                                    <Route path="comms/pipeline" element={<CommsPipeline />} />
                                    <Route path="comms/categories" element={<CommsCategories />} />
                                    <Route path="comms/actions" element={<CommsAgentActions />} />
                                    <Route path="comms/models" element={<CommsModels />} />
                                    {/* Legacy bookmarks from when this was labelled "LBA". */}
                                    <Route path="lba-batches" element={<Navigate to="/comms/loc-batches" replace />} />
                                    <Route path="lba-replies" element={<Navigate to="/comms/mailboxes" replace />} />
                                    <Route
                                        path="lba-detached"
                                        element={<Navigate to="/comms/mailboxes/all?tab=received" replace />}
                                    />
                                    <Route path="srds-home" element={<SrdsHome />} />
                                    <Route path="srds/client/:clientId" element={<SrdsClient />} />
                                    <Route path="srds/claim/:claimId" element={<SrdsClaim />} />
                                </>
                            )}
                        </Route>
                        <Route path="*" element={<PageNotFound />} />
                    </Route>
                </Routes>
            </Router>
        </ToastProvider>
    )
}
